import { A2filter } from "../../common";
import { DataSource } from "@angular/cdk/collections";
import { Injectable, Self } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { BehaviorSubject, merge, Observable } from "rxjs";
import { switchMap } from 'rxjs/operators';

@Injectable()
export class GenericDsService<T>{
  query(paginator: any, sort: any, filter: any): any{};
  onChange?():any{};
}

export class A2TableDatasource<Model> extends DataSource<Model> {
  private loadingSubject = new BehaviorSubject<boolean>(false);
  public loading$ = this.loadingSubject.asObservable();
  public paginator: MatPaginator;
  public sort: MatSort;
  public count = 0;
  public a2filter: A2filter;

  constructor(
    @Self() private dsService: GenericDsService<Model>,
    public source: 'elastic' | 'firebase' = 'elastic'
  ) {
    super()
  }

  connect():Observable<Model[]>{
    const dataMutations = [
      this.paginator.page,
      this.sort.sortChange,
      this.a2filter.filterChange
    ];

    return merge(...dataMutations).pipe(switchMap((qry): Observable<Model[]> => {
      this.loadingSubject.next(true);
      if(qry['filterName']) this.paginator?.firstPage();
      
      return this.dsService.query(this.paginator, this.sort, this.a2filter.filters )
      .then(response=>{
        let data = []
        if (this.source === 'elastic'){
          this.count = response?._meta.count;
          data =  response?.data;
        }else{
          data = response;
          this.count = response.length;
        }
        this.loadingSubject.next(false);
        return data;
      })
      .catch(err =>{
        this.loadingSubject.next(false);
        console.error("data Source Fail", err)
      })
    }));
  }

  disconnect(){
    this.loadingSubject.complete();
  }
}
